<template>
  <EmptyLayout></EmptyLayout>
</template>

<script>
import { mapState } from 'vuex';
import EmptyLayout from '@/components/EmptyLayout.vue';
import axios from 'axios';
import { Browser } from '@capacitor/browser';
import { isNativeNotWeb } from '@/utils/platform-check';
export default {
  components: { EmptyLayout },
  computed: {
    ...mapState('user', ['token']),
  },
  async ionViewWillEnter() {
    const url = this.$route.query.q;
    const fromUrl = this.$route.query.from;
    if (url) {
      // call backend to track analytics
      console.log('url redirect:', url);
      await this.registerAnalyticBackend(url, fromUrl);
      console.log('url after reigster analytics:', url);
      await Browser.open({
        url: url,
      });
      if (isNativeNotWeb()) {
        if (window.history.state && window.history.state.back) {
          this.$router.back();
        } else {
          this.$router.replace(fromUrl || '/');
        }
      } else {
        this.$router.push(fromUrl).then(() => {
          window.location.reload();
        });
      }
    } else {
      this.$router.push('/');
    }
  },
  methods: {
    async registerAnalyticBackend(url, from) {
      try {
        console.log('registrating anlaytics backend');
        await axios.request(process.env.VUE_APP_API_URL + '/analytics/external-link', {
          method: 'post',
          data: { url: url, from: from },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        console.log('registrating anlaytics backend end');
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>

<style scoped></style>
